import { Nullable } from '@jamesgmarks/utilities';
import { Container, Form, Button, Col } from 'react-bootstrap';
import React, { useState } from 'react';
import { login } from '../../redux/features/auth/actions';

/**
 * Standalone login form component.
 *
 * Renders an email/password form and calls {@link login} on submission.
 * Does not accept props — post-login redirect to `/dashboard` is handled by `App.tsx`.
 * Previously accepted an `isLoggedIn` prop and rendered a navigation list; that responsibility
 * has been moved to {@link DashboardContainer}.
 */
export const LoginForm = () => {
  const [ email, setEmail ] = useState<Nullable<string>>(null);
  const [ password, setPassword ] = useState<Nullable<string>>(null);

  return (
    <div>
      <Container>
        <h1>Login</h1>
        <Form
          onSubmit={(e) => {
            login({ email: email ?? '', password: password ?? '' });
            setPassword('');
            e.preventDefault();
          }}
        >
          <Form.Row>
            <Form.Group as={Col} controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="text"
                placeholder="Email"
                value={email ?? ''}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                value={password ?? ''}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>
          </Form.Row>
          <Button variant="primary" type="submit">
            Log In
          </Button>
        </Form>
      </Container>
    </div>
  );
};
